import styled from 'styled-components'

const PositionWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

/** @component */
export default PositionWrapper
